import React, {useState, useEffect} from 'react';
import {NavLink, Redirect} from 'react-router-dom';
import {setKey} from "../store/actions";
import {connect} from "react-redux";
import keys from "../store/keys";
import {swalError} from "../utils/swal";
import categoryService from "../services/category";
import constants from '../utils/constants';
import utils from '../utils/utils';

function CategoriesHeader({
                              session,
                              setKey,
                              ...props
                          }) {

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        reload();
    }, []);

    const reload = async () => {
        await categoryService.getAll()
            .then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }
                setCategories(result.data);
            });
    }

    const handleChangeCategory = (e, val) => {
        setKey(keys.searchCategoryId, val._id);
        setKey(keys.searchCategory, val.title);
        setKey(keys.searchCategories, ``);

        document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
        document.querySelector(`.nav-categories .browse-all`).classList.remove("nav-categories-active");
        e.target.parentElement.classList.add("nav-categories-active");
    }

    const handleBrowseAll = e => {
        setKey(keys.searchCategoryId, ``); 
        setKey(keys.searchCategory, ``);
        setKey(keys.searchCategories, ``);
        setKey(keys.searchBrands, ``);
		setKey(keys.searchPriceMin, constants.minPrice);
		setKey(keys.searchPriceMax, constants.maxPrice);

        document.querySelectorAll(`.nav-categories .nav-item`).forEach(k => k.classList.remove("nav-categories-active"));
        e.target.parentElement.classList.add("nav-categories-active");

        document.querySelectorAll(`.Collapsible__contentInner .form-check-input`).forEach(k => k.checked = false);
    }

    const renderCategories = () => {
        return categories.map(x => {
            const id = `nav-link-${utils.replaceAll(" ", "", x.title)}`.toLowerCase();
            return <li className={`nav-item ${x._id}`} key={x._id}>
                <NavLink className="nav-link" id={id} onClick={e => handleChangeCategory(e, x)} to='/'>{x.title}</NavLink>
            </li>
        });
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light nav-categories" style={{paddingLeft: 52, paddingRight: 52, height: 60}}>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item browse-all">
                            <NavLink className="nav-link" onClick={handleBrowseAll} to='/' style={{fontWeight: 600}}>
                                Browse All
                            </NavLink>
                        </li>
                        {renderCategories()}
                    </ul>
                </div>
            </nav>
        </>
    );
}

const mapStateToProps = store => ({session: store.session});
const mapDispatchToProps = dispatch => ({setKey: (key, value) => dispatch(setKey(key, value))});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesHeader);